<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" select="4" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner8.jpg" width="100%" alt="" />
    <div class="main margin-b flex-row justify-content-spaceBetween align-items-center margin-ts border-b">
      <p class="fs-mid grey margin-bs">当前位置：首页 > 网站地图</p>
    </div>
    <div class="main flex-column justify-content-start align-items-star">
      <div class="width-100" v-for="item in list" :key="item.index">
        <div class="titBox fs-big black margin-b">{{ item.tit }}</div>
        <div class="width-100 border-b padding-b margin-b flex-row flex-wrap justify-content-start align-items-star">
          <div
            v-for="item in item.child"
            :key="item.index"
            @click="jumpTo(item.url, item.index)"
            class="flex-row justify-content-start align-items-center label"
          >
            <span class="fs-sml margin-rs lineHeight1 myBlue">◆</span>
            <p class="fs-mid">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
    <backBtn></backBtn>

    <footerBox class="margin-t"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';

export default {
  name: 'HelloWorld',
  components: {
    tab,
    footerBox,
    backBtn
  },
  data() {
    return {
      currentPage: 1,
      list: [
        {
          index: 0,
          tit: '集团概况',
          child: [
            {
              index: 0,
              text: '集团简介',
              url: '/group'
            },
            {
              index: 1,
              text: '组织架构',
              url: '/group'
            },
            {
              index: 2,
              text: '部室介绍',
              url: '/group'
            },
            {
              index: 3,
              text: '发展历程',
              url: '/group'
            }
          ]
        },
        {
          index: 1,
          tit: '新闻中心',
          child: [
            {
              index: 0,
              text: '集团动态',
              url: '/news'
            },
            {
              index: 1,
              text: '辖属动态',
              url: '/news'
            },
            {
              index: 3,
              text: '党群活动',
              url: '/news'
            }
          ]
        },
        {
          index: 2,
          tit: '下属企业',
          child: [
            {
              index: 0,
              text: '全资企业',
              type: 16,
              url: '/enterprise'
            },
            {
              index: 1,
              text: '控股企业',
              type: 17,
              url: '/enterprise'
            },
            {
              index: 2,
              text: '参股企业',
              type: 22,
              url: '/enterprise'
            },
            {
              index: 3,
              text: '全管企业',
              type: 23,
              url: '/enterprise'
            }
          ]
        }
      ]
    };
  },
  mounted() {},

  created() {},
  methods: {
    jumpTo(e, param) {
      let text = this.$router.resolve({ path: e, query: { Id: param } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.titBox {
  border-left: 4px solid rgb(11, 73, 158) !important;
  width: 98%;
  padding-left: 1%;
}
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}

.border-b {
  border-bottom: 1px solid #eeeeee;
}
.padding-b {
  padding-bottom: 20px;
}
.box {
  max-height: 140px;
  padding: 20px 3%;
  width: 94%;
}
.label {
  width: 140px;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
</style>
